
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotel-room-in-shimla/[slug]",
      function () {
        return require("private-next-pages/hotel-room-in-shimla/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotel-room-in-shimla/[slug]"])
      });
    }
  